var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asl-remote-header-buttons",class:{ ['menu-open']: _vm.globalState.menuOpen === true }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }